export enum IResourceContentTypeEnum {
  ScormResource,
  FileResource,
  WebLinkResource,
}
